import React                from 'react';
import { useNavigate }      from 'react-router-dom';
import { useTranslation }   from 'react-i18next';
import MerceDanneggiataIcon from '../../images/MerceDanneggiata.svg';

import { 
    Card, 
    CardContent, 
    Typography, 
    Button, 
    Box, 
    Avatar, 
    Tooltip, 
    IconButton 
} from '@mui/material';

const MerceDanneggiata = ({ resiAperti }) => {
    
    //costanti
    const navigate = useNavigate();
    const {t} = useTranslation();


    //funzioni
    const handleAvviaResoClick = () => {
        navigate('/MerceDanneggiata');  
    };

    const handleResoClick = () => {
        navigate('/dettaglioResi', { state: { tipoReso: 'MerceDanneggiata' } });
    };

return (
    <Box 
    sx={{ 
        position: 'relative', 
        width: '100%',
        minWidth: {sx: '0px', md: '600px'},
        overflow: 'visible' ,
        

    }}
    >
    <Card 
        sx={{ 
        width: '100%', 
        minHeight: '275px',
        height: 'auto',
        py: 1,
        borderRadius: 4, 
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', 
        position: 'relative',
        overflow: 'visible',
        border: 'solid 1px #dddddd',
        }}
    >
        <CardContent sx={{ height: '100%', position: 'relative' }}>
        <Box sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 3
        }}>
        <Avatar 
            sx={{ 
            width: 70, 
            height: 70,
            borderRadius: '16px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
            overflow: 'visible', 
            backgroundImage: 'linear-gradient(90deg, #123727 0%, #3DFD5D 100%)',
            }}
        >
            <img src={MerceDanneggiataIcon} alt="Merce danneggiata icon" style={{ width: '70%', height: '70%' }} /> 
            </Avatar>
            <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2
                }}>
                <Typography sx={{ color: '#237a3a', fontWeight: 'medium'}}> {t('I tuoi resi')}: </Typography>
            <Tooltip title={t('I tuoi resi')}>
            <IconButton 
                onClick={handleResoClick}
                sx={{
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                border: 'solid 2px #24893e',
                width: 60,
                height: 60,
                color: '#24893e',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                '&:hover': {
                    transform: 'scale(1.05)',
                }
                }}
            >
                <Typography variant="h5" fontWeight="bold">{ resiAperti }</Typography>
            </IconButton>
            </Tooltip>
            </Box>
            </Box>

            {/* Titolo e descrizione */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: { xs: 'column', md: 'row' }, 
                justifyContent: 'space-between', 
                alignItems: { md: 'center' }, 
                pr: 3, 
                pl: 3, 
                pt: 5 
            }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', mt: 6 }}>
                    <Typography variant="h6" fontWeight="bold">
                        {t('Merce Danneggiata')}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" mb={2}>
                        {t('La merce è arrivata danneggiata.')}
                    </Typography>
                </Box>
                {/* Pulsante */}
                <Box 
                    
                    display="flex" 
                    justifyContent={{ xs: 'flex-end' }} 
                    sx={{ pt: { xs: 2, md: 0 }, width: '50%', mt: 6 }}
                >
                    <Button
                    onClick={handleAvviaResoClick}
                    variant="contained"
                    sx={{
                        color: 'white',
                        borderRadius: '20px',
                        textTransform: 'none',
                        width: 140,  
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                        backgroundImage: 'linear-gradient(90deg, #123727 0%, #3DFD5D 100%)',
                        '&:hover': {
                            backgroundImage: 'linear-gradient(90deg, #123727 0%, #3DFD5D 100%)',
                        }
                    }}
                    >
                    {t('Avvia Reso')}
                    </Button>
                </Box>
            </Box>
        </CardContent>
    </Card>
    </Box>
);
};

export default MerceDanneggiata;
